
<ng-template [ngIf]="isLoadingRegistraEM">
      <app-loading></app-loading>
</ng-template>

<div class="d-flex mt-2">
  <form [formGroup]="registraEmForm">
      <div class="grid formgrid p-fluid">
        <div class="field mt-2 mb-2 col-3">
            <label for="codice" class="font-medium text-900 text-blue-600 font-bold">Codice</label>
            <input type="text" pInputText formControlName="codice"/>

        </div>
        <div class="field mt-2 mb-2 col-3">
          <label for="valore" class="font-medium text-900 text-green-600 font-bold">Valore</label>
          <p-inputNumber mode="currency" inputId="valore" currency="EUR" locale="it-IT" formControlName="valore" [styleClass]="'right-align'"> </p-inputNumber>
      </div>
        <div class="field mt-2 mb-2 col-6">
            <label for="dataEmissione" class="font-medium text-900 text-orange-600 font-bold">Data di Emissione</label>
            <p-calendar formControlName="dataEmissione" [readonlyInput]="true"  [appendTo]="'body'"></p-calendar>
        </div>

      </div>
  </form>
</div>
<div class="surface-border border-top-1 opacity-50 mb-3 col-12"></div>
<div class="margin-top-1" style="text-align: center; display: flex; justify-content: center; align-items: center;">
    <p-button icon="pi pi-times" (onClick)="conferma(false)" label="Annulla" class="p-button-text mr-2"
    styleClass="p-button-warning"></p-button>
   <p-button  icon="pi pi-check" label="Conferma"
        class="p-button-text ml-100" styleClass="p-button-success" (click)="conferma(true)" [disabled]="isLoadingRegistraEM || !registraEmForm.valid"></p-button>
</div>
<p-toast />